import type { HelpPermission } from "./types";

/**
 * Z-order relative to the modal layer. Fluent v8 Layers sit at 1 000 000 and
 * Fluent v9 portals append to <body>; everything the guide renders sits above
 * app dialogs (react-toastify stays on top at 9 999 999).
 */
const M = 1_000_000;
export const Z = {
  launcherCopy: M + 1,
  drawer: M + 2,
  tourOverlay: M + 20,
  tourCard: M + 21,
  inspectHighlight: M + 20,
  inspectCard: M + 21,
  inspectBanner: M + 22,
  stepJump: M + 25,
};

export const DRAWER_WIDTH = 440;
export const PEEK_WIDTH = 14;
/** Drawer slide is 225 ms; wait a little longer before measuring tour targets. */
export const DRAWER_TRANSITION_MS = 225;
export const AFTER_DRAWER_MS = 260;

/** i18next keys for the "who can see this" badge. */
export const PERMISSION_LABEL_KEY: Record<HelpPermission, [string, string]> = {
  canEdit: ["help.permission.canEdit", "Admins and internal users"],
  canDelete: ["help.permission.canDelete", "Admins only"],
  canViewSettings: ["help.permission.canViewSettings", "Admins and read-only admins"],
  canEditSettings: ["help.permission.canEditSettings", "Admins only"],
  canInvalidateOffers: ["help.permission.canInvalidateOffers", "Admins and internal users"],
  canMarkOffersAsError: ["help.permission.canMarkOffersAsError", "Admins only"],
  canChooseOffersShowMode: ["help.permission.canChooseOffersShowMode", "Admins and read-only admins"],
};
